export default __webpack_public_path__ + "static/media/tickMark.bea546d4.svg";